// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Actions
import * as actions from '../store/actions';

// Components
import { TableCard } from 'components/content-containers/cards';
import { Table } from 'components/content-containers/tables/tables';
import FlipMove from 'components/widgets/animation/flip-move';
import { ShortDate } from 'components/widgets/dates';
import AddBilling from 'components/models/agreement/add-billing';
import EditBillingPopup from 'components/models/agreement/edit-billing-popup';
import { InvoiceLink } from 'components/widgets/icons/link-icons';

// Utils
import { currency } from 'utils/format-utils';
import replaceById from 'utils/replace-by-id';


// Component
class AgreementBillings extends React.Component {
  static propTypes = {
    load: PropTypes.func,
    agreement: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.eagerUpdate = this.eagerUpdate.bind(this);
  }

  eagerUpdate(values) {
    const { agreement } = this.props;

    const updated = _.defaults({
      billings: replaceById(values, agreement.billings)
    }, agreement);

    actions.set({ agreement: updated });
  }

  render() {
    const { agreement, load } = this.props;
    const billings = _.orderBy(agreement.billings, ['releaseDate']);

    return (
      <div className="agreement-billings flex flex-equal-children">
        <div className="billing-form-wrapper">
          <AddBilling agreement={agreement} load={load} />
        </div>
        <TableCard className="billings-table">
          <Table>
            <thead>
              <tr>
                <th className="collapse-width">Release Date</th>
                <th>Description</th>
                <th className="collapse-width">Type</th>
                <th className="collapse-width right-align">Amount</th>
                <th className="collapse-width"></th>
              </tr>
            </thead>
            <FlipMove typeName="tbody" enterAnimation="fade" leaveAnimation="fade">
              {_.map(billings, billing =>
                <tr key={billing.id}>
                  <td><ShortDate date={billing.releaseDate} /></td>
                  <td>{billing.description}</td>
                  <td>{billing.type}</td>
                  <td className="right-align">{currency(billing.amount)}</td>
                  <td className="right-align options-cell no-padding">
                    { billing.invoice && <InvoiceLink className="svg-only-button" invoiceId={billing.invoice} /> }
                    <EditBillingPopup billing={billing} eagerUpdate={this.eagerUpdate} />
                  </td>
                </tr>
              )}
            </FlipMove>
          </Table>
        </TableCard>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  agreement: state.agreements.agreement
}))(AgreementBillings);



// WEBPACK FOOTER //
// ./app/routes/agreement/sub-routes/agreement-billings.js